module.exports = __webpack_public_path__ + "img/rank2.1d595061.png";